module.exports = __webpack_public_path__ + "static/media/natty-champs.a2fa15af.jpg";